import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SuchePage } from './suche.page';

const routes: Routes = [
  {
    path: '',
    component: SuchePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SuchePageRoutingModule {}
